var d = {
  CustomEvent: "ce",
  Pr: "p",
  bc: "pc",
  Ac: "ca",
  Su: "i",
  qu: "ie",
  ts: "cci",
  rs: "ccic",
  Mt: "ccc",
  Wt: "ccd",
  Fl: "ss",
  Dl: "se",
  Ki: "si",
  Li: "sc",
  Qi: "sbc",
  Mc: "sfe",
  Do: "iec",
  vc: "lr",
  fc: "uae",
  ss: "ci",
  Ot: "cc",
  yc: "lcaa",
  kc: "lcar",
  Hn: "inc",
  On: "add",
  Gn: "rem",
  $n: "set",
  Bn: "ncam",
  jc: "sgu",
  yr: "ffi",
  ro: "bi",
  ct: "bc"
},
    dr = {
  Fr: "feed_displayed",
  Sc: "content_cards_displayed"
};
export { d as EventTypes, dr as InternalEventTypes };